import type { ReactNode } from 'react'

/**
 * The key facts of a relation (design §4.4/§4.5): a small card of label/value pairs at
 * the top of Overzicht. Three columns only when the card itself is wide enough for them
 * (a container query): the middle column of the relation page is 350-430 px wide for
 * part of the range above 1024 px, whatever the window is.
 */
export function KeyFacts({
  title = 'Kerngegevens',
  facts,
}: {
  title?: string
  facts: { label: string; value: ReactNode }[]
}) {
  return (
    <section aria-label={title} className="@container vonk-card flex flex-col gap-3 p-5">
      <h2 className="font-heading text-base font-semibold">{title}</h2>
      <dl className="grid grid-cols-2 gap-x-6 gap-y-3 @min-[31rem]:grid-cols-3">
        {facts.map((fact) => (
          <div key={fact.label}>
            <dt className="text-xs text-muted-foreground">{fact.label}</dt>
            <dd className="text-sm font-medium break-words">{fact.value}</dd>
          </div>
        ))}
      </dl>
    </section>
  )
}
